import { render, staticRenderFns } from "./authors-edit.vue?vue&type=template&id=c100de5e&scoped=true&"
import script from "./authors-edit.vue?vue&type=script&lang=js&"
export * from "./authors-edit.vue?vue&type=script&lang=js&"
import style0 from "./authors-edit.vue?vue&type=style&index=0&id=c100de5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c100de5e",
  null
  
)

export default component.exports